<template>
  <div class="view-information-about-delete-profile">
    <app-content-title-back-home title="Как удалить аккаунт?" />
    <div class="view-information-about-delete-profile__content">
      <ol class="view-information-about-delete-profile__list">
        <li class="view-information-about-delete-profile__list-item">
          1. Напишите письмо в
          <router-link class="app-green-link" to="/messenger"
            >техническую поддержку</router-link
          >
          и укажите ваш email.
        </li>
      </ol>

      <div class="view-information-about-delete-profile__information">
        Обратите внимание, что после удаления учетной записи вы не сможете
        восстановить доступ или вновь зарегистрироваться на сайте под той же
        почтой.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewInformationAboutDeleteProfile',
  components: {
    AppContentTitleBackHome: () =>
      import('@/components/common/AppContentTitleBackHome'),
  },
};
</script>

<style lang="scss">
.view-information-about-delete-profile {
  &__list {
    @include list-reset;

    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
  }

  &__list-item {
    line-height: 10px;
  }

  &__information {
    line-height: 17px;
    color: #aaadb4;
  }
}
</style>
